module.exports = __webpack_public_path__ + "media/images/client/favicons/android-chrome-384x384-30b9b7504eb6c9fd066e2eff82929241.png";